<template>
  <div class="options">
    <p><span>팩에 담을 제품과</span> <span>하루동안 섭취할 총 정/캡슐 개수를 선택해주세요.</span></p>
    <span>제품 별 표기된 1일 권장량 정보를 참고해주세요.</span>
    <div
      class="category_btn"
      :class="classFixed"
    >
      <button
        type="button"
        data-link="section1"
        class="ddd"
        :class="{ 'active' : VMGroupVisible}"
        @click="$emit('jump-to', groupTypes[0].groupCode)"
      >
        비타민·무기질·유산균
      </button>
      <button
        type="button"
        data-link="section2"
        class="ddd"
        :class="{ 'active' : FGroupVisible}"
        @click="$emit('jump-to', groupTypes[1].groupCode)"
      >
        기능성
      </button>
    </div>
  </div>
</template>
<script>
import { log } from '@/utils/common';

function grabScrollEvent() {
  // console.log(window.pageYOffset);
  if (window.pageYOffset > 321 - 16) {
    this.sticky = true;
  } else {
    this.sticky = false;
  }
}

export default {
  name: 'ProductTypeSelection',
  components: {
  },
  props: {
    groupTypes: {
      type: Array,
      default: () => [],
    },

    groupVisible: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      bindedHandler: null,
      sticky: false,
    };
  },
  computed: {
    classFixed() {
      return this.sticky ? 'fixed' : '';
    },
    VMGroupVisible() {
      return this.groupVisible.find((n) => n.groupCode === 'V/M').visible && this.sticky;
    },
    FGroupVisible() {
      return this.groupVisible.find((n) => n.groupCode === 'F').visible && this.sticky;
    },
  },
  watch: {
    sticky() {
      this.$emit('sticky', this.sticky);
    },
  },
  mounted() {
    log('ProductTypeSelection::mounted');
    this.bindedHandler = grabScrollEvent.bind(this);
    window.addEventListener('scroll', this.bindedHandler);
  },
  beforeDestroy() {
    log('ProductTypeSelection::beforeDestroy');
    window.removeEventListener('scroll', this.bindedHandler);
  },
};
</script>



// WEBPACK FOOTER //
// src/views/composition/main/step1/ProductTypeSelection.vue